import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useBodyshopBranchReducer = () => useSelector((state: ApplicationState) => state.bodyshopBranch);
